import {
  Checkbox,
  Dialog,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DialogPropsType } from "../../../types/common";
import { useTranslation } from "react-i18next";
import { EmployeeIncentivation } from "../../../types/employeeScores";
import { IncentivationDataType } from "../../../types/actionModule/rewardCalculationType/incentivationDataType";
import { BaseRewardCalculationInformation, ScoreRewardCalculationInformation, BinaryRewardCalculationInformation, ManualInputRewardCalculationInformation } from "../../../types/actionModule/instance/rewardCalculationInformation";

interface DocumentPreviewModalProps {
  dialog: DialogPropsType;
  data: EmployeeIncentivation[];
}

export default function ExcelPreviewModal(props: DocumentPreviewModalProps) {
  const { t } = useTranslation();
  const { open, handleDialogClose } = props.dialog;

  if (props.data.length === 0) {
    return (
      <Dialog open={open} onClose={handleDialogClose}>
        <Paper sx={{ p: 3, textAlign: "center", minWidth: 300 }}>
          {t("employeesPage.errors.noData")}
        </Paper>
      </Dialog>
    );
  }

  const subTypeKeys = new Set(props.data.flatMap(row => row.subTypeData !== undefined
    ? Object.keys(row.subTypeData)
    : []
  ));
  const subtypeColumns = [...subTypeKeys];

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      sx={{
        ".MuiPaper-root": {
          maxWidth: "1000px",
        },
      }}
    >
      <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
        <Table stickyHeader aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  fontWeight: "bold",
                }}
              >
                {t("tableColumnHeaders.employeeNo")}
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  fontWeight: "bold",
                }}
              >
                {t("tableColumnHeaders.score")}
              </TableCell>

              {subtypeColumns.map(col => (
                <TableCell
                  key={col}
                  sx={{
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((row, idx: number) => (
              <TableRow
                key={idx}
                sx={{
                  "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
                  "&:hover": { backgroundColor: "#f1f5f9" },
                }}
              >
                <TableCell>{row.employeeNumber}</TableCell>
                <TableCell>
                  <RewardCalculationView rewardCalculationInformation={row.rewardCalculationInformation} />
                </TableCell>

                {subtypeColumns.map(col => (
                  <TableCell key={col}>
                    {row.subTypeData?.[col] ?? "-"}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Dialog>
  );
};

interface Props {
  rewardCalculationInformation: BaseRewardCalculationInformation;
}

function RewardCalculationView(props: Props) {

  switch (props.rewardCalculationInformation.incentivationDataType) {
    case IncentivationDataType.Score:
      return <>{(props.rewardCalculationInformation as ScoreRewardCalculationInformation).score}</>;
    case IncentivationDataType.Binary:
      return <Checkbox
        checked={(props.rewardCalculationInformation as BinaryRewardCalculationInformation).isFulfilled}
        onChange={() => { }}
      />;
    case IncentivationDataType.ManualInput:
      return <>{(props.rewardCalculationInformation as ManualInputRewardCalculationInformation).enteredReward}</>;
    case IncentivationDataType.None:
      return <>-</>;
  }
}